import { createFileRoute, notFound } from '@tanstack/react-router';

import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// /dev/fluxo (só dev): a F5 (wizard e tabela de amortização) para teste humano. Fora do DEV a rota
// não existe e a página não entra no bundle.
export const Route = createFileRoute('/dev/fluxo/')({
  validateSearch: flowSearchSchema(),
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound é o contrato do Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'FlowDevPage') : () => null,
});
